import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import SAMPLE_ENTRIES from "../../data/time-tracker/sample";
import TimeTrackerCli from "./TimeTrackerCli";

const SectionStyled = styled.section`
  padding: 96px 0;
  background: var(--nd-black);
`;

const Label = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-secondary);
  margin: 0 0 16px;
`;

const Title = styled.h1`
  font-family: 'Doto', 'Space Mono', monospace;
  font-size: 48px;
  font-weight: 700;
  color: var(--nd-text-display);
  letter-spacing: -0.02em;
  line-height: 1.05;
  margin: 0 0 12px;
  @media (max-width: 768px) { font-size: 32px; }
`;

const Subtitle = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 16px;
  color: var(--nd-text-secondary);
  line-height: 1.5;
  margin: 0 0 32px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Th = styled.th`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-secondary);
  text-align: left;
  padding: 12px 8px;
  border-bottom: 1px solid var(--nd-border);
`;

const Td = styled.td`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 14px;
  color: var(--nd-text-primary);
  padding: 12px 8px;
  border-bottom: 1px solid var(--nd-border);
`;

const HoursTd = styled(Td)`
  font-family: 'Space Mono', monospace;
  text-align: right;
`;

const TimeTrackerPreview = () => (
  <SectionStyled>
    <Container>
      <Label>TIME TRACKER · PREVIEW</Label>
      <Title>Sample week</Title>
      <Subtitle>Read-only sample. Sign in to view your own hours.</Subtitle>
      <TimeTrackerCli />
      <Table>
        <thead>
          <tr>
            <Th>Date</Th>
            <Th>Project</Th>
            <Th>Task</Th>
            <Th style={{ textAlign: "right" }}>Hours</Th>
          </tr>
        </thead>
        <tbody>
          {SAMPLE_ENTRIES.map((e) => (
            <tr key={e.id}>
              <Td>{e.date}</Td>
              <Td>{e.project}</Td>
              <Td>{e.task}</Td>
              <HoursTd>{e.hours.toFixed(1)}</HoursTd>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  </SectionStyled>
);

export default TimeTrackerPreview;
